import type { InvitePlatform } from "./inviteTypes";

export const PODSCOPE_INVITE_MESSAGE_TYPE = "podscope:prixi-invite-complete";

const DEFAULT_PRIXI_FRONTEND_ORIGINS = [
  "http://localhost:3002",
  "http://localhost:3004",
  "https://prixi.cl",
  "https://www.prixi.cl",
  "https://prixi-frontend.onrender.com",
];

export function getAllowedPrixiFrontendOrigins(): string[] {
  const fromEnv = process.env.REACT_APP_PRIXI_FRONTEND_ORIGINS?.trim();
  if (!fromEnv) return DEFAULT_PRIXI_FRONTEND_ORIGINS;
  const fromList = fromEnv
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return Array.from(new Set([...fromList, ...DEFAULT_PRIXI_FRONTEND_ORIGINS]));
}

function resolveOpenerTargetOrigins(): string[] {
  try {
    if (document.referrer) {
      const origin = new URL(document.referrer).origin;
      const allowed = getAllowedPrixiFrontendOrigins();
      if (allowed.includes(origin)) return [origin];
    }
  } catch {
    // ignore malformed referrer
  }
  return getAllowedPrixiFrontendOrigins();
}

export function notifyPrixiOpener(opts: {
  platform: InvitePlatform;
  status: "success" | "disconnected";
}): void {
  const opener = window.opener;
  if (!opener || opener.closed) return;

  const payload = {
    type: PODSCOPE_INVITE_MESSAGE_TYPE,
    platform: opts.platform,
    status: opts.status,
  };

  for (const origin of resolveOpenerTargetOrigins()) {
    try {
      opener.postMessage(payload, origin);
    } catch {
      // ignore postMessage failures for non-matching origins
    }
  }

  try {
    opener.focus();
  } catch {
    // focus may be blocked by browser policy
  }
}
